const clearEmpty = (data) => {
  Object.keys(data).forEach((key) => {
    if (data[key] === '' || data[key] === undefined || data[key] === null) {
      delete data[key]
    }
  })
  return data
}

const formInitialValues = (fields, initialValues, setValue) => {
  fields.forEach((f) => {
    if (f.ignoreOnEdit || initialValues[f.name] === '') return
    setValue(f.name, initialValues[f.name] || '')
  })
}

const formDefaultValues = (fields, setValue) => {
  fields.forEach((f) => {
    setValue(f.name, f.defaultValue || '')
  })
}

const renderFields = (watch, audience, getValues) => {
  if (watch('audience') === '') return []

  const a = (audience.list || []).find((x) => x._id === getValues('audience'))

  if (!a) return []

  const k = Object.keys(a.contacts[0])
  return k
}

export const formHelper = {
  clearEmpty,
  formInitialValues,
  formDefaultValues,
  renderFields
}
